(function () {

  'use strict';

  eclipseApp.directive('usageDetailsRealtime', function () {
    return {
      restrict: 'E',
      scope: {
        newCycleStart: '=',
        ctn: '=',
        ban: '=',
        realTimeUsageData: '=',
        initiatePricePlanChange : '=',
        broadcastPlanData: '=',
        refreshDial: '&',
        dialRefreshed: '='
      },
      replace: true,
      templateUrl: 'modules/core/views/usage-details-realtime.html',
      controller: 'usageDetailsRealtimeCtrl'

    };
  });

})();
